import { useContext, useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import {
  desoLogin,
  checking,
  uploadImagesToDeso,
  setShowIFrame,
  helpingFunction,
  updateProfile,
  updateFollow,
  desoLoginSuccess,
  checkUser,
  unsubscribeAction,
  withoutDeriveKeySubscibeAction,
  changeSignAction,
  selectedTweetsTransferAction,
  getInfoAction,
  identityWindowAction,
  helpingApi,
  changeWaterMarkAction,
} from "../reducers/auth/action";
import { v4 as uuid } from "uuid";
import { ConfigContext } from "../context/config";
import { Subject } from "rxjs";
import { getAnalytics, logEvent } from "firebase/analytics";

const analytics = getAnalytics();

const useIdentity = () => {
  const dispatch = useDispatch();
  const { twitter, check } = useSelector((state) => state?.auth);
  let {
    iframe,
    selectButton,
    anotherCheck,
    updateProfileState,
    followApiState,
    selectTweetState,
  } = useContext(ConfigContext);
  // outbounded Requests
  const req = {};
  // pending Requests
  const [pendingReqs, setPendingReqs] = useState([]);
  const [initialized, setInitialized] = useState(false);

  const handleMessage = (event, identityWindow) => {
    const { data } = event;
    const { service, method } = data;

    if (service !== "identity") {
      return;
    }

    // Methods are present on incoming requests but not responses
    if (method) {
      handleRequest(event, identityWindow);
    } else {
      handleResponse(event);
    }
  };

  const handleResponse = (event) => {
    const {
      data: { id, payload },
    } = event;

    const request = req[id];
    if (request) {
      request?.next(payload);
      request?.complete();
      delete req[id];
    }
  };

  const handleRequest = (event, identityWindow) => {
    const {
      data: { id, method, payload },
    } = event;
    if (method === "initialize") {
      handleInitialize(event);
    } else if (method === "login") {
      handleLogin(payload, identityWindow);
    } else if (method === "info") {
      handleInfo(id, payload);
    } else if (method === "storageGranted") {
      handleStorageGranted();
    } else if (method === "derive") {
      handleDerive(payload, identityWindow);
    } else {
      console.error("Unhandled identity request");
      console.error(event);
    }
  };

  const getJWT = (payload) => {
    return send("jwt", payload);
  };

  const handleInitialize = (event) => {
    if (!initialized) {
      setInitialized(true);
      for (let request of pendingReqs) {
        postMessage(request);
      }
      setPendingReqs([]);
    }

    // acknowledge, provides hostname data
    respond(event.source, event.data.id, {});
  };

  const handleDerive = (payload, identityWindow) => {
    if (identityWindow.current !== null) {
      identityWindow.current.close();
    }
    dispatch(helpingFunction(payload, signTransaction, getJWT, getInfo));
  };

  const handleLogin = (payload, identityWindow) => {
    let chk = sessionStorage.getItem("method");
    if (
      chk === "derived-cred-callback" ||
      chk === "sTranUp" ||
      chk === "sTransUProfile"
    ) {
      if (payload?.signedTransactionHex) {
        sessionStorage.setItem(
          "derived-payload",
          payload?.signedTransactionHex
        );
      }
      if (identityWindowAction !== null) {
        identityWindowAction.close();
      }
    } else {
      dispatch(desoLoginSuccess(payload));
      const pn = window.location.pathname;
      if (pn != "/profile") {
        dispatch(checkUser(signTransaction, getJWT));
      } else {
        sessionStorage.setItem("showIFrame", "true");
      }
      dispatch(desoLogin(payload, signTransaction));
      if (localStorage.getItem("credential") === null) {
        logEvent(analytics, "deso_login", {
          uid: twitter?.user?.uid,
          ...payload,
        });
      }
      localStorage.setItem("credential", JSON.stringify(payload));

      if (identityWindow.current !== null) {
        identityWindow.current.close();
      }
    }
  };

  // credentials

  useEffect(() => {
    if (updateProfileState) {
      dispatch(updateProfile(signTransaction, getJWT, getInfo));
    }
  }, [updateProfileState]);

  useEffect(() => {
    if (followApiState) {
      dispatch(updateFollow(signTransaction));
    }
  }, [followApiState]);

  useEffect(() => {
    if (check || anotherCheck) {
      dispatch(checking(twitter?.user?.uid, signTransaction, getJWT, getInfo));
    }
  }, [check, selectButton, anotherCheck]);

  const unsubscribeIdentity = () => {
    dispatch(unsubscribeAction(signTransaction, getJWT, getInfo, getInfo));
  };
  const withoutDeriveKeySubscibeIdentity = () => {
    console.log("withoutDeriveKeySubscibeIdentity");
    dispatch(withoutDeriveKeySubscibeAction(signTransaction, getJWT, getInfo));
  };
  const changeSignIdentity = () => {
    console.log("changeSignIdentity");
    dispatch(changeSignAction(signTransaction, getJWT, getInfo));
  };
  const selectedTweetsTransferIdentity = () => {
    dispatch(selectedTweetsTransferAction(signTransaction, getJWT, getInfo));
  };

  const changeWatermarkIdentity = (status_set) => {
    dispatch(changeWaterMarkAction(getJWT, getInfo, status_set));
  };

  const handleInfo = (id, payload) => {
    console.log("handleInfo", id);
  };

  const handleStorageGranted = () => {
    dispatch(setShowIFrame(false));
    const status = sessionStorage.getItem("storage_granted");
    if (status) {
      if (status == "change_subscription") {
        changeSignIdentity();
      } else if (status == "unsubscribe") {
        unsubscribeIdentity();
      } else if (status == "without_key_subscribe") {
        withoutDeriveKeySubscibeIdentity();
      } else if (status == "selected_tweets_transfer") {
        selectedTweetsTransferIdentity();
      } else if (status == "created_subcription") {
        handleDerive();
      }
    }
    // const status = localStorage.getItem("show_info_iframe");
    // if (status == "unsubscribe") {
    //   dispatch(unsubscribeAction(signTransaction, getJWT, getInfo));
    // } else {
    //   dispatch(updateProfile(signTransaction, getJWT, getInfo));
    // }
  };

  const signTransaction = (payload) => {
    return send("sign", payload);
  };

  const getInfo = (payload) => {
    return send("info", payload);
  };

  const getinfoIdentity = () => {
    dispatch(getInfoAction(getInfo));
  };

  const send = (method, payload) => {
    const requestToSend = {
      id: uuid(),
      method,
      payload,
      service: "identity",
    };

    postMessage(requestToSend);

    const subject = new Subject();
    req[requestToSend?.id] = subject;
    return subject;
  };

  const postMessage = (request) => {
    if (iframe.current !== null) {
      iframe.current.contentWindow.postMessage(request, "*");
    } else {
      setPendingReqs((prevReq) => [...prevReq, request]);
    }
  };

  // Respond to a received message
  const respond = (window, id, payload) => {
    window?.postMessage({ id, service: "identity", payload }, "*");
  };
  return {
    handleMessage,
    signTransaction,
    getJWT,
    getInfo,
    unsubscribeIdentity,
    withoutDeriveKeySubscibeIdentity,
    changeSignIdentity,
    selectedTweetsTransferIdentity,
    getinfoIdentity,
    changeWatermarkIdentity,
  };
};

export default useIdentity;
